// extracted by mini-css-extract-plugin
export default {"hidden":"hidden__ifsL1","desktop":"desktop__aH9Pi","burgerOpen":"burgerOpen__EWv6i","burgerClose":"burgerClose__slq+n","light":"light__V+irS","dark":"dark__SsUc8"};